export default {
  cn: {
    next: '下一页',
    prev: '上一页',
    first: '首页',
    last: '尾页',
    close_btn: '关闭 (Esc键)',
    loading: '读取中...',
    page_info: '第 page_num/page_count 页( 共 row_count 条记录 )',
    not_found: '无查询结果',
    server_error: '连接到服务器时发生错误！',
    clear: '清除内容',
    select_all: '选择当前页项目',
    unselect_all: '取消选择当前页项目',
    clear_all: '清除全部已选择项目',
    max_selected: '最多只能选择 max_selected_limit 个项目',
    placeholder: '请选择一个项目',
    items_selected: '已选择 selected_count 个项目'
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/component/dic/language.js
// module id = 17
// module chunks = 0